import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { PoStatusBadge, PoTypeChip, money } from './poShared';

export const LinkedPosCard = ({ api, param, id, testId = 'linked-pos' }) => {
  const [pos, setPos] = useState([]);
  useEffect(() => { if (id) api().get('/purchase-orders', { params: { [param]: id } }).then(r => setPos(r.data || [])).catch(() => {}); }, [api, param, id]);
  if (!pos.length) return null;
  const live = pos.filter(p => p.status !== 'Canceled');
  return (
    <div className="border border-slate-200 rounded-sm bg-white" data-testid={testId}>
      <div className="flex items-center justify-between px-4 py-2 border-b border-slate-100 text-sm">
        <span className="font-semibold flex items-center gap-1.5"><ShoppingCart className="w-4 h-4" /> Purchase Orders ({pos.length})</span>
        <span className="text-xs">Parts cost <strong className="mono" data-testid={`${testId}-total`}>{money(live.reduce((s, p) => s + p.total, 0))}</strong></span>
      </div>
      {pos.map(p => (
        <Link key={p.id} to={`/purchasing/pos/${p.id}`} className="flex items-center justify-between px-4 py-1.5 text-sm hover:bg-slate-50 border-t border-slate-50">
          <span className="flex items-center gap-2"><span className="mono font-semibold">{p.po_number}</span><PoTypeChip po={p} /><span className="text-slate-500">{p.vendor_name_snapshot}</span></span>
          <span className="flex items-center gap-2"><span className="mono">{money(p.total)}</span><PoStatusBadge status={p.status} /></span>
        </Link>
      ))}
    </div>
  );
};

export default LinkedPosCard;
